import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import Action from './Action';
import ImageMessage from './ImageMessage';
import { executeAction } from '../utils/message';

import { COLORS } from '../constants/styles';
import { MESSAGE_ITEM, COMPLEX_IMAGE } from '../constants/dimensions';
import { IMAGE_ASPECT_RATIO, MESSAGE_TYPES } from '../constants/message';

const styles = {
    carouselItem: {
        maxWidth: `${MESSAGE_ITEM.WIDTH}px`,
        minWidth: `${MESSAGE_ITEM.WIDTH}px`,
        verticalAlign: 'top',
        fontSize: 'initial',
        backgroundColor: COLORS.WHITE,
        border: `1px solid ${COLORS.GRAY_GALLERY}`,
        overflow: 'hidden',
        marginRight: '5px',
    },
    defaultAction: {
        cursor: 'pointer',
    },
    defaultActionContainer: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        overflow: 'hidden',
        transition: 'all 0.3s ease-out',
        height: '100%',
    },
    image: {
        height: `${COMPLEX_IMAGE.HEIGHT}px`,
        overflow: 'hidden',
    },
    title: {
        margin: '15px 8px 5px',
        fontWeight: '500',
        fontSize: '15px',
        color: COLORS.BLACK_COD,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    description: {
        margin: '0px 8px 13px',
        fontSize: '13px',
        color: COLORS.GRAY_CHARCOAL,
        whiteSpace: 'pre-wrap',
    },
    actions: {
        margin: '0px 0px 5px',
    },
};

export default class CarouselItem extends PureComponent {
    static propTypes = {
        dispatch: PropTypes.func.isRequired,
        actions: PropTypes.array.isRequired,
        mediaUrl: PropTypes.string,
        title: PropTypes.string.isRequired,
        description: PropTypes.string,
        isFirstItem: PropTypes.bool.isRequired,
        isLastItem: PropTypes.bool.isRequired,
        displaySettings: PropTypes.object,
        linkColor: PropTypes.string,
    };

    onItemClick = (defaultAction) => {
        const { dispatch } = this.props;
        executeAction(dispatch, defaultAction);
    };

    render() {
        const {
            isFirstItem,
            isLastItem,
            mediaUrl,
            actions: messageActions,
            title,
            description,
            linkColor,
            displaySettings,
        } = this.props;

        let defaultAction;

        const imageProps = {
            imageAspectRatio: displaySettings ? displaySettings.imageAspectRatio : IMAGE_ASPECT_RATIO.HORIZONTAL,
            mediaUrl,
            type: MESSAGE_TYPES.IMAGE,
        };

        const imageStyle = {
            ...styles.image,
        };

        const carouselItemStyle = {
            ...styles.carouselItem,
        };

        if (isFirstItem) {
            carouselItemStyle.borderRadius = '14px 0px 0px 14px';
        }

        if (isLastItem) {
            carouselItemStyle.marginRight = '0px';
            if (isFirstItem) {
                carouselItemStyle.borderRadius = '14px';
            } else {
                carouselItemStyle.borderRadius = '0px 14px 14px 0px';
            }
        }

        if (displaySettings && displaySettings.imageAspectRatio === IMAGE_ASPECT_RATIO.SQUARE) {
            imageStyle.height = COMPLEX_IMAGE.SQUARE.HEIGHT;
        }

        const actions = messageActions.map((action) => {
            if (!defaultAction && action.default) {
                defaultAction = action;
            }

            return <Action key={action._id} buttonColor={linkColor} inlineButton={true} {...action} />;
        });

        const defaultActionStyle = {
            ...styles.defaultActionContainer,
        };

        if (defaultAction) {
            Object.assign(defaultActionStyle, styles.defaultAction);
        }

        return (
            <div ref={(c) => (this._item = c)} className="carousel-item" style={carouselItemStyle}>
                <div className="carousel-content" style={styles.content}>
                    <div style={defaultActionStyle} onClick={defaultAction && (() => this.onItemClick(defaultAction))}>
                        {mediaUrl ? (
                            <div className="carousel-image" style={imageStyle}>
                                <ImageMessage {...imageProps} />
                            </div>
                        ) : null}
                        <div style={styles.title} className="carousel-title">
                            {title}
                        </div>
                        <div style={styles.description} className="carousel-description">
                            {description}
                        </div>
                    </div>
                    <div style={styles.actions}>{actions}</div>
                </div>
            </div>
        );
    }
}
